import { RevisionEditHistory } from "~/classes/models/submitted-documents/revision-history-edit.model";

export const useDocumentRevisionEditHistory = (documentId: string) =>
  defineStore(`/document/revision/edit/history/${documentId}`, () => {
    const activeEditHistoryId = ref<string | undefined>(undefined);
    let writeQueue = Promise.resolve();

    const enqueueWrite = <T>(write: () => Promise<T>) => {
      const result = writeQueue.catch(() => undefined).then(write);
      writeQueue = result.then(
        () => undefined,
        () => undefined
      );

      return result;
    };

    const saveEditHistory = (editHistory: RevisionEditHistory) => {
      return enqueueWrite(async () => {
        if (activeEditHistoryId.value != undefined) {
          editHistory.id = activeEditHistoryId.value;
        }

        await editHistory.save();

        activeEditHistoryId.value = editHistory.id;
      });
    };

    const saveCheckpoint = (editHistory: RevisionEditHistory) => {
      return enqueueWrite(async () => {
        if (activeEditHistoryId.value != undefined) {
          editHistory.id = activeEditHistoryId.value;
        }

        await editHistory.save();

        activeEditHistoryId.value = undefined;
      });
    };

    return {
      saveEditHistory,
      saveCheckpoint,
    };
  });
